import React from 'react';

import NoAccess from '../NoAccess/index';

import { Row } from 'antd';

import Iframe from 'react-iframe';
import { hot } from 'react-hot-loader';

export default hot(module)(function Dashboard({ authorized }) {
	if (!authorized) {
		return <NoAccess />;
	}

	return (
		<>
			<Row style={{ margin: '15px 0px' }}>
				<Iframe
					width="1280"
					height="1800"
					src="https://lookerstudio.google.com/embed/reporting/44432a39-af42-45ca-af36-ef0bce7bdd9d/page/dn2ZD"
					frameborder="0"
					style="border:0"
					allowfullscreen
				/>
			</Row>
		</>
	);
});
